module.exports = __webpack_public_path__ + "img/logo.9852e999.png";